<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="title-header">
            <h2>Endereço incorreto ou desatualizado</h2>
        </div>

        <div class="section-container-address" *ngIf="formattedAddress">
            <div class="address-content-wrapper">
                <img class="img-class" src="assets/images/marca-x.png" />
                <div class="address-text">
                    <span class="row"><b>Endereço: </b></span>
                    <span>{{ formattedAddress }}</span>
                </div>
            </div>
        </div>

        <div class="section-container" *ngIf="!formattedAddress">
            <span><b>Endereço não encontrado</b></span>
        </div>

        <div *ngIf="patient">
            <div class="section-container">
                <div class="row section-personal-data">
                    <h3>Confirme os dados abaixo para envio do link de edição.</h3>

                    <div *ngIf="patient.socialName">
                        <mat-form-field appearance="outline" class="full-width form-field-totem">
                            <mat-label>Nome:</mat-label>
                            <input matInput type="text" [value]="patient.socialName" readonly>
                        </mat-form-field>
                    </div>

                    <div *ngIf="patient.patientName && !patient.socialName">
                        <mat-form-field appearance="outline" class="full-width form-field-totem">
                            <mat-label>Nome:</mat-label>
                            <input matInput type="text" [value]="patient.patientName" readonly>
                        </mat-form-field>
                    </div>

                    <div *ngIf="phoneMask">
                        <mat-form-field appearance="outline" class="full-width form-field-totem">
                            <mat-label>Telefone:</mat-label>
                            <input matInput type="text" [value]="phoneMask" readonly>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="footer-confirm-modal-list">
    <button mat-flat-button color="primary" class="btn-block button-send-link" (click)="sendLinkAndContinue()">
        Enviar link e Continuar
    </button>
    <button mat-flat-button color="accent" class="btn-block" (click)="return()">
        Voltar
    </button>
</div>